var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Auth } from "aws-amplify";
import config from "../../assests/config";
import { setLocalStorage } from "../../helpers/storage";
import { getOriginalEmailId, getIdCardDetails } from "./api";
const nextAuth = {
    SMS_MFA: "OTP",
    SOFTWARE_TOKEN_MFA: "OTP",
    NEW_PASSWORD_REQUIRED: "FTP",
};
export const storeAuthUserDetails = ({ userDetails, authUserInfo: { authUserInfo }, eMail, }) => {
    var _a, _b;
    const { memberIdCardList } = userDetails;
    setLocalStorage("Member_EMPID", memberIdCardList[0].empId);
    memberIdCardList.forEach((data) => {
        var _a;
        (_a = data === null || data === void 0 ? void 0 : data.planInfo) === null || _a === void 0 ? void 0 : _a.find(({ idcardField }) => {
            return idcardField === "contact number";
        });
    });
    const memberData = memberIdCardList[memberIdCardList.length - 1];
    const contact = (_a = memberData === null || memberData === void 0 ? void 0 : memberData.planInfo) === null || _a === void 0 ? void 0 : _a.find(({ idcardField }) => idcardField === "contact number");
    [
        { key: "SOURCE", value: memberData === null || memberData === void 0 ? void 0 : memberData.source },
        { key: "CLIENT_ID", value: memberData === null || memberData === void 0 ? void 0 : memberData.clientId },
        { key: "sourceid", value: memberIdCardList === null || memberIdCardList === void 0 ? void 0 : memberIdCardList[0].memberId },
        { key: "CONTACT_NUMBER", value: (contact === null || contact === void 0 ? void 0 : contact.fieldValue) || "NA" },
        { key: "userMail", value: eMail },
        { key: "subscriberName", value: (_b = authUserInfo === null || authUserInfo === void 0 ? void 0 : authUserInfo.attributes) === null || _b === void 0 ? void 0 : _b.name },
        { key: "planId", value: memberData === null || memberData === void 0 ? void 0 : memberData.planId },
    ].forEach(({ key, value }) => setLocalStorage(key, value));
    if ((memberData === null || memberData === void 0 ? void 0 : memberData.source) === "NEO") {
        setLocalStorage("Member_EMPID", memberData === null || memberData === void 0 ? void 0 : memberData.source);
    }
};
let authError = "";
export const signInAuth = ({ appConfig, userInfo, UI }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    authError = "";
    try {
        const emailRequest = {
            sessionURL: appConfig.sessionURL,
            email: userInfo.email,
            brand: appConfig.brand,
        };
        let validEmail;
        if (UI !== config.UI.agency) {
            validEmail = yield getOriginalEmailId(emailRequest);
            emailRequest.email = validEmail;
        }
        let authUserInfo = yield Auth.signIn({
            username: emailRequest.email,
            password: userInfo.password,
        });
        if (!authUserInfo || authError) {
            return Promise.reject({
                message: authError || config.errorMessages.INCORRECT_USER,
                isAuthenticated: false,
            });
        }
        authUserInfo = {
            challengeName: authUserInfo.challengeName,
            authUserInfo,
        };
        let userDetails;
        if (UI !== config.UI.agency) {
            userDetails = yield getIdCardDetails(emailRequest);
            storeAuthUserDetails({
                userDetails,
                authUserInfo,
                eMail: emailRequest.email,
            });
        }
        if (nextAuth[authUserInfo.challengeName]) {
            return Promise.resolve({
                authenticatedUser: authUserInfo,
                nextAuth: nextAuth[authUserInfo.challengeName],
                isAuthenticated: false,
            });
        }
        return Promise.resolve({
            authenticatedUser: authUserInfo.authUserInfo.attributes,
            isAuthenticated: true, // saved all user realted info in storage
        });
    }
    catch (error) {
        console.error(error);
        const message = ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) ||
            (error === null || error === void 0 ? void 0 : error.message) ||
            config.errorMessages.SOMETHING_WRONG;
        authError = message;
        return Promise.reject({
            message,
            isAuthenticated: false,
        });
    }
});
